// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"27ad6259","217":"ae988ee0","808":"82f4bbf9","846":"eaf85450"}[chunkId] + ".chunk.css";
};